export const backendApiCoverageStyles: Record<string, React.CSSProperties> = {
  auditMeta: {
    margin: "0 0 12px",
    color: "var(--color-text-secondary)",
    fontSize: 13,
  },
  cardGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: 12,
    marginBottom: 18,
  },
  card: {
    border: "1px solid var(--color-border)",
    borderRadius: 8,
    padding: 14,
    background: "var(--color-bg)",
  },
  cardLabel: {
    color: "var(--color-text-secondary)",
    fontSize: 12,
    fontWeight: 700,
  },
  cardValue: {
    display: "block",
    marginTop: 6,
    fontFamily: "var(--font-mono)",
    fontSize: 24,
    fontWeight: 800,
  },
  section: {
    marginTop: 24,
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    marginBottom: 10,
  },
  sectionTitle: {
    margin: 0,
    fontSize: 16,
    fontWeight: 800,
  },
  browserShell: {
    display: "grid",
    gridTemplateColumns: "340px minmax(0, 1fr)",
    gap: 16,
    alignItems: "start",
    marginTop: 18,
  },
  apiTreePanel: {
    position: "sticky",
    top: 16,
    maxHeight: "calc(100vh - 120px)",
    overflow: "auto",
    border: "1px solid var(--color-border)",
    borderRadius: 8,
    padding: 12,
    background: "var(--color-bg)",
  },
  apiTreeHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 8,
    marginBottom: 10,
  },
  apiTree: {
    display: "grid",
    gap: 8,
    marginTop: 10,
  },
  apiTreeModule: {
    cursor: "pointer",
    padding: "8px 6px",
    borderRadius: 6,
    background: "var(--color-bg-muted)",
    color: "var(--color-text)",
    fontWeight: 800,
  },
  apiTreeCount: {
    float: "right",
    color: "var(--color-text-secondary)",
    fontSize: 12,
    fontWeight: 700,
  },
  apiTreeEndpointList: {
    display: "grid",
    gap: 4,
    padding: "6px 0 0 8px",
  },
  apiTreeEndpoint: {
    display: "grid",
    gap: 3,
    padding: "7px 8px",
    border: "1px solid transparent",
    borderRadius: 6,
    color: "var(--color-text)",
    textDecoration: "none",
  },
  apiTreeEndpointActive: {
    borderColor: "var(--color-primary)",
    background: "#eff6ff",
  },
  apiTreeEndpointTop: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    minWidth: 0,
  },
  apiTreePath: {
    minWidth: 0,
    overflow: "hidden",
    fontFamily: "var(--font-mono)",
    fontSize: 12,
    fontWeight: 800,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  apiTreeTitle: {
    overflow: "hidden",
    color: "var(--color-text-secondary)",
    fontSize: 12,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  apiDetailPanel: {
    minWidth: 0,
  },
  filterGrid: {
    display: "grid",
    gridTemplateColumns: "minmax(260px, 1.5fr) repeat(4, minmax(140px, 0.7fr))",
    gap: 8,
    alignItems: "center",
    marginBottom: 12,
  },
  input: {
    height: 34,
    minWidth: 0,
    padding: "0 10px",
    border: "1px solid var(--color-border)",
    borderRadius: 6,
    background: "var(--color-bg)",
    color: "var(--color-text)",
  },
  select: {
    height: 34,
    minWidth: 0,
    padding: "0 8px",
    border: "1px solid var(--color-border)",
    borderRadius: 6,
    background: "var(--color-bg)",
    color: "var(--color-text)",
  },
  tableScroll: {
    overflowX: "auto",
    border: "1px solid var(--color-border)",
    borderRadius: 8,
  },
  table: {
    width: "100%",
    minWidth: 1120,
    borderCollapse: "collapse",
    tableLayout: "fixed",
    fontSize: 13,
  },
  th: {
    textAlign: "left",
    padding: "10px",
    borderBottom: "1px solid var(--color-border)",
    background: "var(--color-bg-muted)",
    color: "var(--color-text-secondary)",
    fontSize: 12,
  },
  td: {
    padding: "10px",
    borderBottom: "1px solid var(--color-border)",
    verticalAlign: "top",
  },
  methodBadge: {
    display: "inline-flex",
    alignItems: "center",
    minWidth: 52,
    justifyContent: "center",
    marginRight: 8,
    padding: "2px 7px",
    borderRadius: 5,
    background: "var(--color-bg-muted)",
    fontFamily: "var(--font-mono)",
    fontSize: 11,
    fontWeight: 800,
  },
  pathText: {
    fontFamily: "var(--font-mono)",
    overflowWrap: "anywhere",
    fontWeight: 700,
  },
  pathLink: {
    fontFamily: "var(--font-mono)",
    overflowWrap: "anywhere",
    fontWeight: 800,
    color: "var(--color-primary)",
    textDecoration: "none",
  },
  groupHeader: {
    padding: "10px",
    borderBottom: "1px solid var(--color-border)",
    background: "var(--color-bg-muted)",
    color: "var(--color-text-secondary)",
    fontSize: 12,
    fontWeight: 800,
  },
  meta: {
    display: "block",
    marginTop: 5,
    color: "var(--color-text-secondary)",
    fontSize: 11,
    overflowWrap: "anywhere",
  },
  statusPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: 5,
    padding: "3px 8px",
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 800,
  },
  testList: {
    display: "grid",
    gap: 6,
    maxHeight: 360,
    overflow: "auto",
  },
  testDetails: {
    border: "1px solid var(--color-border)",
    borderRadius: 6,
    padding: "6px 8px",
    background: "var(--color-bg)",
  },
  testSummary: {
    cursor: "pointer",
    fontWeight: 700,
    lineHeight: 1.4,
  },
  testLogic: {
    margin: "6px 0 0",
    color: "var(--color-text-secondary)",
    lineHeight: 1.5,
  },
  testTypeGoal: {
    margin: "6px 0 8px",
    color: "var(--color-text-secondary)",
    fontSize: 12,
    lineHeight: 1.45,
  },
  pager: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: 8,
    marginTop: 10,
  },
  pagerButton: {
    padding: "5px 10px",
    border: "1px solid var(--color-border)",
    borderRadius: 6,
    background: "var(--color-bg)",
    color: "var(--color-text)",
  },
  detailGrid: {
    display: "grid",
    gap: 14,
  },
  detailSection: {
    border: "1px solid var(--color-border)",
    borderRadius: 8,
    padding: 14,
    background: "var(--color-bg)",
  },
  detailTable: {
    width: "100%",
    borderCollapse: "collapse",
    tableLayout: "fixed",
    fontSize: 13,
  },
  metaRow: {
    display: "grid",
    gridTemplateColumns: "180px 1fr",
    gap: 12,
    margin: "8px 0",
    lineHeight: 1.5,
  },
  codeList: {
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
  },
  codePill: {
    padding: "4px 7px",
    borderRadius: 6,
    background: "var(--color-bg-muted)",
    color: "var(--color-text)",
    fontSize: 12,
  },
};
